import {Observable} from 'rxjs';

import {signal, Signal, WritableSignal} from '@angular/core';

export function getAttributeObservable<T>(targetElement: HTMLElement, attributeName: string): Observable<T> {
	return new Observable<T>(observer => {
		const mutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
			mutations.forEach(mutation => {
				if (mutation.type === 'attributes' && mutation.attributeName === attributeName) {
					const value = targetElement.getAttribute(attributeName) as T;
					observer.next(value);
				}
			});
		});

		mutationObserver.observe(targetElement, {
			attributes: true,
			attributeOldValue: true,
			attributeFilter: [attributeName],
		});
	});
}

export function getAttributeSignal<T>(targetElement: HTMLElement, attributeName: string): Signal<T> {
	const _Signal: WritableSignal<T> = signal(null);
	const mutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
		mutations.forEach(mutation => {
			if (mutation.type === 'attributes' && mutation.attributeName === attributeName) {
				const value = targetElement.getAttribute(attributeName) as T;
				if (mutation.oldValue !== value) {
					_Signal.set(value);
				}
			}
		});
	});

	mutationObserver.observe(targetElement, {
		attributes: true,
		attributeOldValue: true,
		attributeFilter: [attributeName],
	});

	return _Signal;
}
